<div class="ui container">
  <div class="ui stackable grid header">
    <div class="row">
      <div class="sixteen wide column column">
        <h1 class="ui inverted header left floated" *ngIf="userProfile">
          {{ userProfile &&
          (userProfile.osu_username || userProfile.name) }}'s
          profile
        </h1>
        <a class="right floated ui button" *ngIf="isMe" href="/logout"
          onclick="event.preventDefault(); document.getElementById('logout-form').submit();">
          <i class="sign out icon"></i>
          Log out
        </a>
        <a class="right floated ui primary button" *ngIf="isMe"
          href="/profile">
          Edit profile
        </a>
      </div>
    </div>
  </div>

  <div *ngIf="fetching" class="ui basic very padded segment">
    <div class="ui inverted active centered inline huge text loader">
      Loading profile...
    </div>
  </div>

  <div *ngIf="!fetching" class="">
    <div class="ui grid">
      <div class="column">
        <h2>
          Profile Info &nbsp;
          <i *ngIf="userProfile.isMod" class="ui big purple label">Site
            Moderator</i>
        </h2>
        <div *ngIf="loggedInUser && loggedInUser.isAdmin">
          <button class="ui red button" *ngIf="!userProfile.banned"
            (click)="banUser()">Ban User
          </button>
          <button class="ui primary button" *ngIf="userProfile.banned"
            (click)="unbanUser()">Unban user
            User
          </button>
        </div>
      </div>
    </div>

    <div class="ui inverted padded segment section">
      <div class="ui divided inverted grid">
        <div class="four column tablet row">
          <div class="column center aligned">
            <h5 class="ui inverted header">osu! Profile</h5>
            <a class="ui primary button" *ngIf="userProfile.osu_username"
              target="_blank" [href]="'https://osu.ppy.sh/users/' + userProfile.osu_username">
              View Profile
            </a>
            <span *ngIf="!userProfile.osu_username">
              Not linked
            </span>
          </div>
          <div class="column">
            <h5 class="ui inverted header">Bounties paid</h5>
            <p>
              <i class="money icon" [class.green]="userProfile.completed_bounties"></i>
              {{ userProfile.completed_bounties || 0 }}
            </p>
          </div>
          <div class="column">
            <h5 class="ui inverted header">Bounties won</h5>
            <p>
              <i class="i trophy icon" [class.yellow]="userProfile.won_bounties"></i>
              {{ userProfile.won_bounties || 0 }}
            </p>
          </div>
          <div class="column">
            <h5 class="ui inverted header">Liked bounties</h5>
            <p>
              <i class="thumbs up icon" [class.blue]="bountiesLiked.length"></i>
              {{ bountiesLiked.length }}
            </p>
          </div>
        </div>

      </div>
    </div>

    <div class="section" *ngIf="payments && payments.length">
      <h2>Bounty pool contributions</h2>
      <table class="ui inverted table">
        <thead>
          <th>Bounty</th>
          <th>Amount</th>
          <th>Status</th>
          <th>Date updated (UTC)</th>
          <th>Refund</th>
        </thead>
        <tbody>
          <tr *ngFor="let payment of payments">
            <td>
              <a [routerLink]="['/bounties', payment.bounty_id]">
                View Bounty
              </a>
            </td>
            <td>
              <i class="small money bill green alternate icon"></i>
              {{ payment.amount | currency }}
            </td>
            <td>
              <div class="ui label" [ngClass]="paymentStatusLabelClass(payment)">
                {{ payment.payment_status }}
              </div>
            </td>
            <td>
              {{ payment.updated_at | date:'short' }}
            </td>
            <td>
              <div class="ui inverted button" *ngIf="payment.payment_status === 'approved'"
                (click)="refundPayment(payment)"
                [class.disabled]="refunding" [class.loading]="refunding">
                Request refund
              </div>
              <div *ngIf="payment.payment_status === 'refunded'">
                Refunded
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="ui red inverted segment" *ngIf="refundError">
        <h5>Error during refund request</h5>
        {{ refundError }}
        <p>Please contact a site admin to resolve this issue.</p>
      </div>
    </div>

    <div class="section">
      <h2>Bounties created</h2>
      <div *ngIf="bountiesCreated.length">
        <app-bounties-table [bounties]="bountiesCreated" [color]="''"></app-bounties-table>
      </div>
      <div *ngIf="!bountiesCreated.length">
        <p>No bounties created yet.</p>
      </div>
    </div>

    <div class="section">
      <h2>Bounties claimed</h2>
      <div *ngIf="bountiesClaimed.length">
        <app-bounties-table [bounties]="bountiesClaimed" [color]="''"></app-bounties-table>
      </div>
      <div *ngIf="!bountiesClaimed.length">
        <p>No bounty rewards won yet.</p>
      </div>
    </div>

    <div class="section">
      <h2>Liked bounties</h2>
      <div *ngIf="bountiesLiked.length">
        <app-bounties-table [bounties]="bountiesLiked" [color]="''"></app-bounties-table>
      </div>
      <div *ngIf="!bountiesLiked.length">
        <p>No bounties liked yet.</p>
      </div>
    </div>
  </div>

</div>
